'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var populationNodes = _to_consumable_array(document.querySelectorAll('.population'));
var parsePopulation = function(str) {
    if (typeof str !== 'string') return NaN;
    var num = Number(str.replaceAll(',', '').trim());
    return !Number.isNaN(num) ? num : NaN;
};
var population = populationNodes.map(function(node) {
    return parsePopulation(node.textContent);
});
var totalPopulation = population.reduce(function(acc, n) {
    return acc + n;
}, 0);
var averagePopulation = population.length ? Math.round(totalPopulation / population.length) : NaN;
var average = document.querySelector('.average-population');
var total = document.querySelector('.total-population');
if (average) average.textContent = averagePopulation.toLocaleString();
if (total) total.textContent = totalPopulation.toLocaleString();

//# sourceMappingURL=js_get_data_DOM.8cfe394e.js.map
